import { useEffect, useState } from "react";
import { Compass, X, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import StrategicGoalWizard from "@/app/components/StrategicGoalWizard";

const DISMISS_KEY = "stupeco:strategic-prompt-dismissed";

export default function StrategicGoalPrompt() {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancel = false;
    (async () => {
      if (typeof window !== "undefined" && sessionStorage.getItem(DISMISS_KEY) === "1") return;
      try {
        const { data } = await api.get("/goals");
        const hasStrategic = (data.goals || []).some((g) => g.goal_type === "strategic");
        if (!cancel && !hasStrategic) setVisible(true);
      } catch { /* silent */ }
    })();
    return () => { cancel = true; };
  }, []);

  const dismiss = () => {
    try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="rounded-2xl border border-brand-teal/40 bg-brand-teal/5 p-4 sm:p-5" data-testid="strategic-goal-prompt">
      <div className="flex items-start gap-3">
        <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl brand-gradient-bg text-white">
          <Compass className="h-5 w-5" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="font-display text-base font-semibold tracking-tight">Define your business direction</p>
          <p className="mt-1 text-sm text-muted-foreground">
            Anchor your Command Center, AI briefing and every recommendation with a Strategic Goal.
            Your AI drafts the roadmap — you approve, edit or skip.
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            <button
              onClick={() => setOpen(true)}
              data-testid="strategic-goal-prompt-cta"
              className="inline-flex items-center gap-1.5 rounded-full brand-gradient-bg px-4 py-2 text-xs font-semibold text-white"
            >
              <Sparkles className="h-3.5 w-3.5" /> Start with AI
            </button>
            <button
              onClick={dismiss}
              data-testid="strategic-goal-prompt-dismiss"
              className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-4 py-2 text-xs font-semibold text-muted-foreground hover:text-foreground"
            >
              Not now
            </button>
          </div>
        </div>
        <button onClick={dismiss} className="text-muted-foreground hover:text-foreground" aria-label="Dismiss" data-testid="strategic-goal-prompt-close">
          <X className="h-4 w-4" />
        </button>
      </div>
      <StrategicGoalWizard
        open={open}
        onOpenChange={setOpen}
        defaultRole="primary"
        onCreated={() => { setOpen(false); setVisible(false); }}
      />
    </div>
  );
}
